module.exports = __webpack_public_path__ + "static/media/RP-A_S_Neutral.fef71925.png";